import React from 'react';
import i18n from '../../i18n';

export default class I18N extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialized: false,
    };
  }

  componentDidMount() {
    const { initialized } = this.state;
    if (!initialized) {
      i18n.initialize().then(() => {
        this.setState({ initialized: true });
      });
    }
  }

  render() {
    const { initialized } = this.state;
    if (!initialized) {
      return (
        <div className="i18n_loading">
        </div>
      );
    }
    return (
        this.props.children
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/I18N/index.js